package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.repository.InventoryRepository
import kotlinx.coroutines.flow.Flow

class ObserveInventoryItemsUseCase(
    private val inventoryRepository: InventoryRepository
) {
    operator fun invoke(characterId: String): Flow<List<InventoryItem>> {
        return inventoryRepository.observeItemsForCharacter(characterId)
    }
}
